export default [
  { label: 'Name', name: 'name', type: 'text' },
  { label: 'Description', name: 'description', type: 'text' },
  { label: 'Price', name: 'price', type: 'text' },
  { label: 'Image', name: 'image', type: 'file' }
];